import ApiInstance from './instance'
import { URL_MAPPING, IUserCredentialsDTO } from '@zunta/configurations'

const { auth } = URL_MAPPING

export default class AuthApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  doLogin (body: IUserCredentialsDTO & { viewportWidth: number, viewportHeight: number }) {
    return this.instance.doPost(`${auth.prefix}${auth.signIn.path}`, body)
  }

  forgotPassword (email: string) {
    return this.instance.doPost(`${auth.prefix}${auth.forgotPassword.path}`, { email })
  }

  getChainManagerToken (data: {chainId: number, roleId?: number}) {
    return this.instance.doPost(`${auth.prefix}${auth.getChainMangerToken.path}/${data.chainId}`, {
      roleId: data.roleId || undefined
    })
  }

  getUserToken (userId: number) {
    return this.instance.doPost(`${auth.prefix}/getUserToken/${userId}`)
  }

  checkPccLogin (username: string, password: string): Promise<boolean> {
    return this.instance.doPost(`${auth.prefix}${auth.checkPccLogin.path}`, { username, password })
  }

  validateCredentials (credentials: IUserCredentialsDTO) {
    return this.instance.doPost(`${auth.prefix}/validateCredentials`, credentials)
  }
}
